export const GET_SETTINGS = 'getSettings'
export const SET_SETTINGS = 'setSettings'
export const SET_LOADING = 'setLoading'
export const SIGN_IN = 'userLogin'
export const SIGN_OUT = 'userLogout'
export const SET_USER = 'setUser'
export const SET_ABILITIES = 'setAbilities'
export const SET_CURRENT_COMPANY = 'currentCompanyId'
export const SET_IS_AUTHENTICATED = 'setIsAuthenticated'
export const PROCESS_FILE = 'processFile'
